var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelebrationTrophyLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 160,
    viewBox: "0 0 144 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734",
    transform: "translate(-4277 -11723.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_trophy_670335_000000",
    d: "M17.709,48h2.3A25.917,25.917,0,0,1,38.133,33.385V24.871H31.785a3.549,3.549,0,0,1-3.548-3.548V16.667H25.07a2.254,2.254,0,0,1-2.291-2.306V2.262A2.262,2.262,0,0,1,25.04,0H62.106a2.259,2.259,0,0,1,2.3,2.262v12.1a2.262,2.262,0,0,1-2.262,2.262h-3.2v4.653A3.546,3.546,0,0,1,55.4,24.823H49.05v8.562A25.916,25.916,0,0,1,67.176,48h2.3a17.7,17.7,0,0,1,17.7,17.712V76.467A2.839,2.839,0,0,1,84.338,79.3H69.474v5.44a2.839,2.839,0,0,1-2.838,2.838h-46.1A2.839,2.839,0,0,1,17.7,84.744V79.294l-14.859,0A2.836,2.836,0,0,1,0,76.459V65.713A17.7,17.7,0,0,1,17.709,48ZM69.475,58.663V70.337h8.743V65.714a8.754,8.754,0,0,0-8.743-8.743H69.42c.026.558.055,1.127.055,1.693ZM32.524,66.571l6.386.946a1.121,1.121,0,0,1,.831.606l2.838,5.78a1.106,1.106,0,0,0,1.988,0l2.838-5.78a1.108,1.108,0,0,1,.831-.606l6.386-.946a1.106,1.106,0,0,0,.613-1.892l-4.616-4.5v0a1.114,1.114,0,0,1-.321-.946l1.086-6.356a1.1,1.1,0,0,0-1.608-1.164l-5.676,3v0a1.106,1.106,0,0,1-1.031,0l-5.676-3v0a1.107,1.107,0,0,0-1.608,1.164l1.086,6.356a1.1,1.1,0,0,1-.321.946l-4.616,4.5v0a1.106,1.106,0,0,0,.588,1.892ZM8.969,70.355h8.74V58.663c0-.569,0-1.134.055-1.693h-.055a8.754,8.754,0,0,0-8.744,8.744Z",
    transform: "translate(4412.193 11846.288) rotate(158)",
    fill: "#84f08d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M45.854,19.626a.7.7,0,0,1,.371.578v4.99a.659.659,0,0,0,1.113.412L50.678,22.1a.583.583,0,0,1,.578,0L56,23.174a.618.618,0,0,0,.748-.453.61.61,0,0,0-.088-.5L54.019,18.1a.583.583,0,0,1,0-.7l2.929-4.123a.661.661,0,0,0-.66-.99l-5.154.826a.706.706,0,0,1-.619-.207L47.668,9.359a.617.617,0,0,0-1.113.33L46.1,14.224a.669.669,0,0,1-.371.537L40.946,16.9a.619.619,0,0,0-.353.8.6.6,0,0,0,.353.353Z",
    transform: "translate(4270.511 11703.029) rotate(20)",
    fill: "#ffba7a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3636",
    "data-name": "Group 3636",
    transform: "translate(4282.557 11638.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M46.144,23.529V19.818a.949.949,0,0,0-1.857-.394,1,1,0,0,0,0,.394v3.711a.949.949,0,0,0,1.857.394A1,1,0,0,0,46.144,23.529Z",
    transform: "translate(-10.623 89.713) rotate(20)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M48.3,24.507l2.64-2.637a.95.95,0,1,0-1.32-1.32l-2.681,2.637a.948.948,0,0,0,1.361,1.32Z",
    transform: "translate(-7.219 93.949) rotate(20)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M47.635,24.477a.946.946,0,0,0,.946.946h3.752a.948.948,0,1,0,.394-1.854,1,1,0,0,0-.394,0H48.748a.952.952,0,0,0-1.1.768A1.134,1.134,0,0,0,47.635,24.477Z",
    transform: "translate(-7.747 100.724) rotate(20)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M49.553,30.242a.949.949,0,0,0,1.279-1.32l-2.64-2.681A.962.962,0,0,0,46.832,27.6Z",
    transform: "translate(-11.289 104.36) rotate(20)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M44.1,27.866v3.752a.989.989,0,0,0,.949.949A.951.951,0,0,0,46,31.618V27.866a.949.949,0,0,0-1.9,0Z",
    transform: "translate(-16.33 104.482) rotate(20)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M43.5,26.108l-2.432,2.6a.949.949,0,0,0,1.32,1.32l2.637-2.681a.948.948,0,0,0-.239-1.32.96.96,0,0,0-1.08,0Z",
    transform: "translate(-21.42 100.463) rotate(20)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M40.407,25.256h3.752a.949.949,0,0,0,0-1.9H40.407a.949.949,0,1,0,0,1.9Z",
    transform: "translate(-22.375 95.009) rotate(20)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M45.082,22.915l-2.64-2.637a.949.949,0,0,0-1.32,1.32l2.64,2.637a.949.949,0,0,0,1.32-1.32Z",
    transform: "translate(-17.544 90.129) rotate(20)",
    fill: "#e2b8e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M55.89,21.88a3.257,3.257,0,1,0-3.256-3.256A3.256,3.256,0,0,0,55.89,21.88Z",
    transform: "translate(4288.204 11722.254) rotate(20)",
    fill: "#84f08d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M55.129,21.685l7.049,3.875a1.164,1.164,0,0,1,.5.5l3.875,7.052a1.2,1.2,0,0,0,2.146,0l4.082-7.052a1.157,1.157,0,0,1,.493-.5l7.093-3.875a1.278,1.278,0,0,0,.429-1.758,1.258,1.258,0,0,0-.429-.429l-7.093-3.834a1.386,1.386,0,0,1-.493-.5L68.655,8.075a1.239,1.239,0,0,0-1.691-.453,1.254,1.254,0,0,0-.456.453l-3.875,7.093a1.394,1.394,0,0,1-.5.5L55.085,19.5A1.241,1.241,0,0,0,54.6,21.18,1.27,1.27,0,0,0,55.129,21.685Z",
    transform: "translate(4298.916 11699.828) rotate(20)",
    fill: "#ff808a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M3.256,0A3.257,3.257,0,1,1,0,3.256,3.256,3.256,0,0,1,3.256,0Z",
    transform: "translate(4399.4 11871.785) rotate(160)",
    fill: "#ffba7a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638",
    transform: "translate(4277 11849.704) rotate(-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M23.473,57.335a5.2,5.2,0,0,0,5.042-6.543,1.113,1.113,0,0,1,.287-1.079,1.131,1.131,0,0,1,1.082-.287,5.211,5.211,0,0,0,6.369-6.372,1.113,1.113,0,0,1,.289-1.082,1.125,1.125,0,0,1,1.079-.284,5.211,5.211,0,0,0,6.372-6.372,1.1,1.1,0,0,1,.287-1.079,1.122,1.122,0,0,1,1.082-.287,5.206,5.206,0,0,0,6.367-6.369,2.049,2.049,0,1,0-3.963,1.043,1.109,1.109,0,0,1-.287,1.082,1.14,1.14,0,0,1-1.082.284,5.209,5.209,0,0,0-6.367,6.377,1.107,1.107,0,0,1-.289,1.074,1.15,1.15,0,0,1-1.084.287A5.208,5.208,0,0,0,32.29,44.1,1.13,1.13,0,0,1,32,45.177a1.115,1.115,0,0,1-1.084.287,5.212,5.212,0,0,0-6.369,6.369,1.125,1.125,0,0,1-.279,1.077,1.136,1.136,0,0,1-1.082.289,2.047,2.047,0,1,0-1.048,3.958A5.026,5.026,0,0,0,23.473,57.335Z",
    transform: "translate(-20.617 -26.055)",
    fill: "#91f2ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3640",
    "data-name": "Group 3640",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 4376.28, 11746.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032-2",
    "data-name": "Path 2032",
    d: "M2.856,0A5.2,5.2,0,0,1,7.9,6.543a1.113,1.113,0,0,0,.287,1.079,1.131,1.131,0,0,0,1.082.287,5.211,5.211,0,0,1,6.369,6.372,1.113,1.113,0,0,0,.289,1.082A1.125,1.125,0,0,0,17,15.647a5.211,5.211,0,0,1,6.372,6.372,1.1,1.1,0,0,0,.287,1.079,1.122,1.122,0,0,0,1.082.287,5.206,5.206,0,0,1,6.367,6.369,2.049,2.049,0,1,1-3.963-1.043,1.109,1.109,0,0,0-.287-1.082,1.14,1.14,0,0,0-1.082-.284,5.21,5.21,0,0,1-6.367-6.377,1.107,1.107,0,0,0-.289-1.074,1.15,1.15,0,0,0-1.084-.287,5.208,5.208,0,0,1-6.367-6.369,1.13,1.13,0,0,0-.287-1.079,1.115,1.115,0,0,0-1.084-.287A5.212,5.212,0,0,1,3.933,5.5a1.125,1.125,0,0,0-.279-1.077,1.136,1.136,0,0,0-1.082-.289A2.047,2.047,0,0,1,1.524.178,5.026,5.026,0,0,1,2.856,0Z",
    transform: "translate(0 0)",
    fill: "#ffef73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3642",
    "data-name": "Group 3642",
    transform: "matrix(-0.087, -0.996, 0.996, -0.087, 4305.968, 11893.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M35.584,26H20.247l7.669-13.285ZM24.472,23.558h6.885L27.913,17.6Z",
    transform: "translate(0)",
    fill: "#e2b8e5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationTrophyLeft);
export default __webpack_public_path__ + "static/media/celebration_trophy_left.e08986bc25f76a13fef52ef2c90a2423.svg";
export { ForwardRef as ReactComponent };